import { en } from '@/shared/lib/common/i18n';
import type { AccountMessage, MessageDelivery } from '@/shared/lib/types/chat';
import { MessageDeliveryState } from '@/shared/lib/types/chat';

// Twilio delivery statuses (stored uppercase by the Backend, matched case-insensitively) mapped to the labels shown under a message.
const DELIVERY_STATE_BY_STATUS: Record<string, MessageDeliveryState> = {
  queued: MessageDeliveryState.SENDING,
  sending: MessageDeliveryState.SENDING,
  accepted: MessageDeliveryState.SENDING,
  scheduled: MessageDeliveryState.SENDING,
  sent: MessageDeliveryState.SENT,
  delivered: MessageDeliveryState.DELIVERED,
  read: MessageDeliveryState.DELIVERED,
  undelivered: MessageDeliveryState.NOT_DELIVERED,
  failed: MessageDeliveryState.NOT_DELIVERED,
  canceled: MessageDeliveryState.NOT_DELIVERED
};

// Only outbound messages with a known status get a delivery line; Dialpad and older messages have none.
export const getMessageDelivery = (message: AccountMessage): MessageDelivery | null => {
  if (message.messageDirection !== 'outbound' || !message.deliveryStatus) return null;

  const state = DELIVERY_STATE_BY_STATUS[message.deliveryStatus.toLowerCase()];
  if (!state) return null;

  return { state, errorCode: message.errorCode, errorMessage: message.errorMessage };
};

export const getMessageDeliveryErrorText = (delivery: MessageDelivery): string | null => {
  if (!delivery.errorCode) return null;

  const { errorWithMessage, errorCodeOnly } = en.messaging.deliveryStatus;
  return delivery.errorMessage ? errorWithMessage(delivery.errorCode, delivery.errorMessage) : errorCodeOnly(delivery.errorCode);
};
